/**
 * List of Session Keys used in application
 * 1. USER
 * 2. LINKS
 * 3. RESOURCES
 * 4. DATA
 * 5. ROW_DATA
 * 6. COMP_ACCESS
 */
export const SESSION_KEYS = {
  USER: 'USER',
  LINKS: 'LINKS',
  RESOURCES: 'RESOURCES',
  DATA: 'DATA',
  ROW_DATA: 'ROW_DATA',
  COMP_ACCESS: 'COMP_ACCESS',
  AUTH_TOKEN: 'AUTH_TOKEN',
  TXN_LIST: 'TXN_LIST',
  MSG_LIST: 'MSG_LIST',
  FROM_SIDEBAR: 'FROM_SIDEBAR',
  CALLER_ID_SEQ: 'callerIdSeq',
  USER_NAME: 'USER_NAME',
  VERIFYLINK:'VERIFYLINK'
};
